import React from "react";
import MaimIslam from "./MaimIslam/MaimIslam";
import HAboutIslam from "./HAboutIslam";
import AboutCardIslam from "../about/AboutCardIslam";
import Header from "../common/header/Header";
import FooterIslam from "../common/footer/FooterIslam";

const Home = () => {
  return (
    <>
{/* <Header/> */}
      <MaimIslam  />
      <AboutCardIslam />
      <HAboutIslam />
        <FooterIslam/>
    </>
  );
};

export default Home;
